import React from 'react';
import './LaunchHeader.css';

const LaunchHeader = (obj: any) => {
	const onChangeValueKeyboard = (e:any)=> {
		if(e.keyCode == 32 || e.keyCode == 13 && obj.onClose){ //32 - spacebar, 36 - enter
			obj.onClose();
		}
	};

	return (
		<div className="launch-header top-shadow-background launch-header-background modal-disable-select">
			<div className="launch-header-front">
				<div className="top-shadow-background close-button-shadow" 
					tabIndex={0}
					onKeyDown={onChangeValueKeyboard}>
					<div title="Close" aria-label="Close" role="button" className="close-button" onClick={obj.onClose}>×</div>
				</div>
				<span className="launch-header-text" tabIndex={0}>{obj.text}</span>
			</div>
		</div>
	);
};

export default LaunchHeader;
